module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_8004.dd30c9a7.png";